import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EventService } from '../../../../services/event.service';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-events-next',
    imports: [
        CommonModule,
        RouterLink,
        MatCardModule,
        MatDividerModule,
        MatButtonModule,
        MatIconModule,
        MarkdownModule,
    ],
    templateUrl: './events-next.component.html',
    styleUrls: ['./events-next.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsNextComponent  {
  eventService = inject(EventService);
}
